module.exports = __webpack_public_path__ + "img/44.6.CODm.92602f6c.png";